<template>
  <div class="lottie-bg">
    <div id="lottie">
      <img src="@assets/images/logo.png" rel="preload" style="width: 100%" />
    </div>
  </div>
</template>

<script>
// import { auth } from "@libs/wechat";
import { auth } from "@libs/wechat-handle";
import { getUserInfo } from "@api/user";
import cookie from "@utils/store/cookie";

export default {
  name: "Loading",
  mounted() {
    const { code, state } = this.$route.query;
    this.$log.wechat("Loading:获取到code", code);
    this.$log.wechat("Loading:获取到state", state);
    this.$log.wechat("Loading:开始获取用户信息");
    try {
      auth(code, state)
        .then(() => {
          this.$log.wechat("auth流程走完，开始获取用户信息，重定向");
          this.$log.wechat("当前的token：", cookie.get("login_status"));
          this.$log.wechat("Loading:授权成功开始获取用户信息");
          getUserInfo().then((res) => {
            this.$log.wechat("Loading:获取到用户信息", res);
            const backUrl = decodeURIComponent(this.$route.params.url);
            this.$log.wechat("Loading:获取到backUrl", backUrl);
            if (backUrl.includes("/login")) {
              this.$log.wechat("Loading:backUrl包含/login，开始重定向");
              this.$router.replace({ path: "/" });
              return;
            } else {
              this.$log.wechat("Loading:backUrl不包含/login，开始重定向");
              location.replace(backUrl);
              return;
            }
          });
        })
        .catch((e) => {
          this.$log.wechat("auth流程走完，登录失败，开始重定向", e);
          // 显示错误对话框并在2秒后重定向
          this.$dialog.error("登录失败，请重新登录");
          setTimeout(() => {
            this.$router.replace("/");
          }, 1000);
        });
    } catch (err) {
      this.$log.wechat("Loading最后流程抛出异常", e);
    }
  },
};
</script>

<style scoped>
.lottie-bg {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#lottie {
  width: 90%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
}
</style>
